import {
  ALL_CARDS_EXPANDED,

  FORM_STATUS_CHANGE,

  RECEIVE_VEROSPREVIEW_UPDATE,

  REQUEST_APPRAISALQAREJECTIONS_RESULTS,
  RECEIVE_APPRAISALQAREJECTIONS_RESULTS,
  ERROR_APPRAISALQAREJECTIONS_RESULTS,
  REQUEST_APPRAISALQAREJECTION_UPDATE,
  RECEIVE_APPRAISALQAREJECTION_UPDATE,
  ERROR_APPRAISALQAREJECTIONS_UPDATE,

  REQUEST_CASEHEADER_RESULTS,
  RECEIVE_CASEHEADER_RESULTS,
  ERROR_CASEHEADER_RESULTS,

  REQUEST_COMPARABLES_RESULTS,
  RECEIVE_COMPARABLES_RESULTS,
  ERROR_COMPARABLES_RESULTS,

  REQUEST_CASECOMPONENT_RESULTS,
  RECEIVE_CASECOMPONENT_RESULTS,
  ERROR_CASECOMPONENT_RESULTS,
  REQUEST_CASECOMPONENTS_RESULTS,
  RECEIVE_CASECOMPONENTS_RESULTS,
  ERROR_CASECOMPONENTS_RESULTS,

  REQUEST_CASEFORMS_RESULTS,
  RECEIVE_CASEFORMS_RESULTS,
  ERROR_CASEFORMS_RESULTS,

  REQUEST_FILES_RESULTS,
  RECEIVE_FILES_RESULTS,
  ERROR_FILES_RESULTS,

  REQUEST_HISTORY_RESULTS,
  RECEIVE_HISTORY_RESULTS,
  ERROR_HISTORY_RESULTS,

  REQUEST_PRIVATENOTES_RESULTS,
  RECEIVE_PRIVATENOTES_RESULTS,
  ERROR_PRIVATENOTES_RESULTS,
  RECEIVE_PRIVATENOTES_UPDATE,

  REQUEST_SKETCH_RESULTS,
  RECEIVE_SKETCH_RESULTS,
  ERROR_SKETCH_RESULTS,

  REQUEST_VALIDATE_FORMS,
  RECEIVE_VALIDATE_FORMS,
  ERROR_VALIDATE_FORMS,

  REQUEST_WORKFLOWMETHOD_RESULTS,
  RECEIVE_WORKFLOWMETHOD_RESULTS,
  ERROR_WORKFLOWMETHOD_RESULTS,
  REQUEST_WORKFLOWSTATUS_RESULTS,
  RECEIVE_WORKFLOWSTATUS_RESULTS,
  ERROR_WORKFLOWSTATUS_RESULTS,
  UPDATE_WORKFLOW_MONITOR,

  SUCCESS_PNX_SAVE,
  ERROR_PNX_SAVE,

  REQUEST_PROP_RECORD_RESULTS,
  RECEIVE_PROP_RECORD_RESULTS,
  ERROR_PROP_RECORD_RESULTS,

  REQUEST_UPDATE_CASEHEADER,
  RECEIVE_UPDATE_CASEHEADER,
  ERROR_UPDATE_CASEHEADER,

  REQUEST_APPRAISAL_FORM_DATA,
  RECEIVE_APPRAISAL_FORM_DATA,
  ERROR_APPRAISAL_FORM_DATA,
  REQUEST_SAVE_1004P_FORM_DATA,
  RECEIVE_SAVE_1004P_FORM_DATA,
  ERROR_SAVE_1004P_FORM_DATA,

  REQUEST_PNX_FORM_EXPORT_DATA,
  RECEIVE_PNX_FORM_EXPORT_DATA,
  ERROR_PNX_FORM_EXPORT_DATA,
  REQUEST_SAVE_PNX_FORM_EXPORT_DATA,
  RECEIVE_SAVE_PNX_FORM_EXPORT_DATA,
  ERROR_SAVE_PNX_FORM_EXPORT_DATA,

  REQUEST_SUBMIT_TO_QA,
  RECEIVE_SUBMIT_TO_QA,
  ERROR_SUBMIT_TO_QA,

  BEGIN_PHOTOS_SORT_ORDER,
  SET_PHOTOS_SORT_ORDER,
  REQUEST_SAVE_PHOTOS_SORT_ORDER,
  ERROR_SAVE_PHOTOS_SORT_ORDER,
  RECEIVE_SAVE_PHOTOS_SORT_ORDER,

  REQUEST_CASE_HEADER,
  RECEIVE_CASE_HEADER,
  ERROR_CASE_HEADER,

  RECEIVE_ALL_CASE_FORMS,
  REQUEST_ALL_CASE_FORMS,
  ERROR_RETRIEVING_ALL_CASE_FORMS,

  REQUEST_AVAILABLE_CASE_FORMS,
  RECEIVE_AVAILABLE_CASE_FORMS,
  ERROR_RETRIEVING_AVAILABLE_CASE_FORMS,

  REQUEST_POST_CASE_FORM,
  RECEIVE_POST_CASE_FORM,
  ERROR_RETRIEVING_POST_CASE_FORM,

  REQUEST_DELETE_CASE_FORM,
  RECEIVE_DELETE_CASE_FORM,
  ERROR_RETRIEVING_DELETE_CASE_FORM,

  MANAGE_FORMS_DIALOG,
  SAVE_COMP_PHOTO_METADATA,
  REQUEST_AI_FORM_VERIFICATION_RESULTS,
  RECEIVE_AI_FORM_VERIFICATION_RESULTS,
  ERROR_AI_FORM_VERIFICATION_RESULTS,
  REQUEST_AI_FORM_VERIFICATION_FORM_RESULTS,
  RECEIVE_AI_FORM_VERIFICATION_FORM_RESULTS,
  ERROR_AI_FORM_VERIFICATION_FORM_RESULTS
} from "typeConstants";
import { cloneDeep } from "lodash";
import { caseForms as initialState } from "reducers/initialState.tsx";

const caseForms = (state = initialState, action) => {
  switch (action.type) {
    // Request Reducers
    case REQUEST_CASEHEADER_RESULTS:
    case REQUEST_COMPARABLES_RESULTS:
    case REQUEST_CASECOMPONENT_RESULTS:
    case REQUEST_CASECOMPONENTS_RESULTS:
      return {
        ...state,
        fetchingHeader: true
      };
    case REQUEST_FILES_RESULTS:
      return {
        ...state,
        fetchingFiles: true
      };
    case REQUEST_HISTORY_RESULTS:
      return {
        ...state,
        fetchingHistory: true
      };
    case BEGIN_PHOTOS_SORT_ORDER:
      return {
        ...state,
        sortingPhotos: true,
      };
    case SET_PHOTOS_SORT_ORDER:
      return {
        ...state,
        photos: {
          ...state.photos,
          photoList: action.payload
        }
      };
    case REQUEST_SAVE_PHOTOS_SORT_ORDER:
      return {
        ...state,
        sortingPhotos: false,
        savingPhotosSort: true
      };
    case RECEIVE_SAVE_PHOTOS_SORT_ORDER:
      return {
        ...state,
        savingPhotosSort: false,
      };
    case ERROR_SAVE_PHOTOS_SORT_ORDER:
      return {
        ...state,
        savingPhotosSort: false,
      };
    case REQUEST_PRIVATENOTES_RESULTS:
      return {
        ...state,
        fetchingPrivateNotes: true
      };
    case REQUEST_CASEFORMS_RESULTS:
      return {
        ...state,
        fetchingCaseFormsList: true,
        // mark other forms as "not in redux store"
        fetchingFiles: true,
        fetchingHeader: true,
        fetchingHistory: true,
        fetchingPrivateNotes: true,
        fetchingSketches: true,
        pnxValidation: {
          fetchingResult: true
        },
      };
    case REQUEST_SKETCH_RESULTS:
      return {
        ...state,
        fetchingSketches: true
      };
    case REQUEST_VALIDATE_FORMS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.validation.finished = false;
      wf.validation.started = true;
      return {
        ...state,
        pnxValidation: {
          fetchingResult: true
        },
        workflowMonitor: wf
      };
    }
    // case REQUEST_VALIDATE_FORMS_SUBMIT:
    //   return {
    //     ...state,
    //     pnxValidation: {
    //       fetchingResult: true,
    //     },
    //     validating: true
    //   };
    // Receive and Update Reducers
    case RECEIVE_CASEHEADER_RESULTS:
    case RECEIVE_COMPARABLES_RESULTS:
    case RECEIVE_CASECOMPONENT_RESULTS:
    case RECEIVE_CASECOMPONENTS_RESULTS:
      return {
        ...state,
        caseHeader: action.payload,
        fetchingHeader: false
      };
    case RECEIVE_FILES_RESULTS:
      return {
        ...state,
        files: action.payload,
        fetchingFiles: false
      };
    case RECEIVE_HISTORY_RESULTS:
      return {
        ...state,
        caseHistory: action.payload,
        fetchingHistory: false
      };
    case RECEIVE_PRIVATENOTES_UPDATE:
    case RECEIVE_PRIVATENOTES_RESULTS:
      return {
        ...state,
        privateNotes: action.payload,
        fetchingPrivateNotes: false
      };
    case RECEIVE_CASEFORMS_RESULTS:
      return {
        ...state,
        caseFormsList: action.payload,
        fetchingCaseFormsList: false,
        fetchingHeader: false
      };
    case RECEIVE_SKETCH_RESULTS:
      return {
        ...state,
        fetchingSketches: false,
        sketches: action.payload
      };
    case REQUEST_AI_FORM_VERIFICATION_RESULTS:
      return {
        ...state,
        aiVerification: {
          controlNumber: action.payload.controlNumber,
          results: null,
          fetchingResults: true,
        },
      };
    case RECEIVE_AI_FORM_VERIFICATION_RESULTS:
      return {
        ...state,
        aiVerification: {
          controlNumber: state.aiVerification.controlNumber,
          results: action.payload,
          fetchingResults: false,
        },
      };
    case ERROR_AI_FORM_VERIFICATION_RESULTS:
      return {
        ...state,
        aiVerification: {
          controlNumber: null,
          results: null,
          fetchingResults: false,
        },
      };
    case REQUEST_AI_FORM_VERIFICATION_FORM_RESULTS:
      return {
        ...state,
        aiVerificationForm: {
          controlNumber: action.payload.controlNumber,
          results: null,
          fetchingResults: true,
        },
      };
    case RECEIVE_AI_FORM_VERIFICATION_FORM_RESULTS:
      return {
        ...state,
        aiVerificationForm: {
          controlNumber: state.aiVerification.controlNumber,
          results: action.payload,
          fetchingResults: false,
        },
      };
    case ERROR_AI_FORM_VERIFICATION_FORM_RESULTS:
      return {
        ...state,
        aiVerificationForm: {
          controlNumber: null,
          results: null,
          fetchingResults: false,
        },
      };
    case RECEIVE_VALIDATE_FORMS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.validation.finished = true;
      wf.validation.success = action.payload.result.success;
      return {
        ...state,
        pnxValidation: {
          fetchingResult: false,
          validateSuccess: action.payload.result.success,
          validationMessages: action.payload.result.messages,
          validationResults: action.payload.result.formValidationResults,
          callback: action.payload.callback
        },
        workflowMonitor: wf
      };
    }
    case RECEIVE_VEROSPREVIEW_UPDATE:
      return {
        ...state,
        caseHistory: {},
        fetchingHistory: true
      };
    // Error reducers
    case ERROR_CASEHEADER_RESULTS:
    case ERROR_COMPARABLES_RESULTS:
    case ERROR_CASECOMPONENT_RESULTS:
    case ERROR_CASECOMPONENTS_RESULTS:
      return {
        ...state,
        caseHeader: {},
        fetchingHeader: false
      };
    case ERROR_FILES_RESULTS:
      return {
        ...state,
        files: {},
        fetchingFiles: false
      };
    case ERROR_HISTORY_RESULTS:
      return {
        ...state,
        caseHistory: {},
        fetchingHistory: false
      };
    case ERROR_PRIVATENOTES_RESULTS:
      return {
        ...state,
        privateNotes: {},
        fetchingPrivateNotes: false
      };
    case ERROR_CASEFORMS_RESULTS:
      return {
        ...state,
        caseForms: [], // we got nothing
        fetchingCaseFormsList: false
      };
    case ERROR_SKETCH_RESULTS:
      return {
        ...state,
        sketches: [],
        fetchingSketches: false
      };
    case SUCCESS_PNX_SAVE:
    case ERROR_PNX_SAVE:
      return state;
    case ERROR_VALIDATE_FORMS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.validation.finished = true;
      wf.validation.success = false;
      return {
        ...state,
        pnxValidation: {
          fetchingResult: false
        },
        workflowMonitor: wf
      };
    }
    case FORM_STATUS_CHANGE: {
      const logToConsole = true;

      let forms = cloneDeep(state.caseFormsList);
      const savedRegex = new RegExp("saveSuccess");
      const formsWithSharedModels = [
        "Comparables with Comparable Search",
        "Uniform Residential Appraisal Report 1004"
      ];

      // Get the form referenced by the current action
      let actionForm = forms.find(f => (f.isPhoenixForm ? f.pnxForm.formId : f.id) === action.payload.id);

      // In the current implementation of the Phoenix forms runtime all Phoenix forms share a separate copy of the full data model
      const actionFormIsPhoenixForm = actionForm && actionForm.pnxForm;
      // These other forms also share the same data model
      let actionFormHasSharedModel =
        formsWithSharedModels.indexOf(action.payload.name) > -1 ||
        actionFormIsPhoenixForm;

      let actionFormId = actionFormIsPhoenixForm ? actionForm.pnxForm.formId : actionForm.id;

      forms.forEach(form => {
        if (actionFormId === action.payload.id) {
          // we don't want form status to be clean if CA window is open
          if (form.formStatus !== "openedComps"){
            form.formStatus = action.payload.status;
          }
        }
        let formHasSharedModel =
          formsWithSharedModels.indexOf(actionFormId) > -1 ||
          (form && form.pnxForm);
        if (
          action.payload.id !== actionFormId &&
          actionFormHasSharedModel &&
          formHasSharedModel
        ) {
          if (savedRegex.test(action.payload.status)) {
            // Tell the form that it needs to refresh
            logToConsole &&
              window.console &&
              window.console.info(form.title + " needsRefresh");
            form.formStatus = "needsRefresh";
            form.formLocked = false;
          } else if (action.payload.status === "dirty") {
            // Tell the form that it should be locked
            logToConsole &&
              window.console &&
              window.console.info(form.title + " locking form");
            form.formLocked = true;
          } else if (action.payload.status === "clean") {
            // Tell the form that does not need to be locked now
            logToConsole &&
              window.console &&
              window.console.info(form.title + " unlocking form");
            form.formLocked = false;
          }
        }
        if (action.payload.status === "openedComps" && formHasSharedModel) {
          // comp search window opened tell forms to lock
          logToConsole &&
            window.console &&
            window.console.info(form.title + " openedComps - locking form");
          form.formLocked = true;
        }
        if (action.payload.status === "closedComps" && formHasSharedModel) {
          // comp search window closed tell forms to refresh
          logToConsole &&
            window.console &&
            window.console.info(form.title + " closedComps - needsRefresh");
          form.formStatus = "needsRefresh";
          form.formLocked = false;
        }
      });

      return {
        ...state,
        caseFormsList: forms,
      };
    }
    case ALL_CARDS_EXPANDED:
      return {
        ...state,
        allCardsExpanded: action.payload.value
      };

    case REQUEST_APPRAISALQAREJECTIONS_RESULTS:
      return {
        ...state,
      };
    case RECEIVE_APPRAISALQAREJECTIONS_RESULTS:
      return {
        ...state,
      };
    case ERROR_APPRAISALQAREJECTIONS_RESULTS:
      return {
        ...state,
      };

    case REQUEST_APPRAISALQAREJECTION_UPDATE:
      return {
        ...state,
      };
    case RECEIVE_APPRAISALQAREJECTION_UPDATE: {
      // Update the rejection info with the resolved rejection
      // let rejections = cloneDeep(state.appraisalQaRejections); // state.appraisalQaRejections.map(value => Object.assign({}, value));
      // let unresolvedAppraiserRejectionCount = 0;
      // rejections.forEach((rejection) => {
      //   if (rejection.id == action.payload.id) {
      //     rejection.responseNotes = action.payload.responseNotes;
      //     rejection.responseDate = action.payload.responseDate;
      //   }
      //   if (!rejection.responseDate) {
      //     unresolvedAppraiserRejectionCount++;
      //   }
      // });
      // // Update the appraisal header count of rejections
      // let caseheader =  cloneDeep(state.caseHeader);
      // caseheader.caseInfo.appraisalSurveyInfo.unresolvedAppraiserRejectionCount = unresolvedAppraiserRejectionCount;
      // caseheader.caseInfo.appraisalSurveyInfo.hasUnresolvedAppraiserRejection = (unresolvedAppraiserRejectionCount > 0);

      return {
        ...state,
        // caseHeader: caseheader,
      };
    }
    case ERROR_APPRAISALQAREJECTIONS_UPDATE:
      return {
        ...state,
      };

    case REQUEST_WORKFLOWMETHOD_RESULTS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.workflowCall.started = true;
      return {
        ...state,
        fetchingWorkflowMethodResult: true,
        workflowMonitor: wf
      };
    }

    case RECEIVE_WORKFLOWMETHOD_RESULTS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.workflowCall.finished = action.payload.isPolling == false;
      wf.workflowCall.success = wf.workflowCall.finished;
      return {
        ...state,
        fetchingWorkflowMethodResult: false,
        workflowStatus: action.payload,
        fetchingWorkflowStatus: false,
        workflowMonitor: wf
      };
    }

    case ERROR_WORKFLOWMETHOD_RESULTS: {
      let wf = cloneDeep(state.workflowMonitor);
      wf.workflowCall.finished = true;
      wf.workflowCall.success = false;
      return {
        ...state,
        fetchingWorkflowMethodResult: false,
        workflowStatus: { error: true },
        fetchingWorkflowStatus: false,
        workflowMonitor: wf
      };
    }

    case REQUEST_WORKFLOWSTATUS_RESULTS:
      return {
        ...state,
        fetchingWorkflowStatus: true
      };

    case RECEIVE_WORKFLOWSTATUS_RESULTS: {
      // need to update workflow Call if present
      let wf = cloneDeep(state.workflowMonitor);
      let ws = action.payload;
      if (
        ws.appraisalWorkflowStatusId != wf.workflowCall.initialWorkflowStatusId
      ) {
        wf.workflowCall.finished = true;
        wf.workflowCall.success = true;
      }
      return {
        ...state,
        workflowStatus: action.payload,
        fetchingWorkflowStatus: false,
        workflowMonitor: wf
      };
    }

    case ERROR_WORKFLOWSTATUS_RESULTS:
      return {
        ...state,
        fetchingWorkflowStatus: false
      };

    case UPDATE_WORKFLOW_MONITOR:
      return {
        ...state,
        workflowMonitor: action.payload
      };
    case REQUEST_PROP_RECORD_RESULTS:
      return {
        ...state,
        isFetchingPublicPropertyRecord: true,
        publicPropertyRecord: {}
      };
    case RECEIVE_PROP_RECORD_RESULTS:
      return {
        ...state,
        isFetchingPublicPropertyRecord: false,
        publicPropertyRecord: action.payload
      };
    case ERROR_PROP_RECORD_RESULTS:
      return {
        ...state,
        isFetchingPublicPropertyRecord: false
      };
    case REQUEST_UPDATE_CASEHEADER:
      return {
        ...state,
        updatingCaseHeader: true
      };
    case RECEIVE_UPDATE_CASEHEADER:
      return {
        ...state,
        updatingCaseHeader: false
      };
    case ERROR_UPDATE_CASEHEADER:
      return {
        ...state,
        updatingCaseHeader: false
      };
    case REQUEST_APPRAISAL_FORM_DATA:
      return {
        ...state,
        isFetchingAppraisalFormData: true,
        dataForAppraisalForm: null
      };
    case RECEIVE_APPRAISAL_FORM_DATA:
      return {
        ...state,
        isFetchingAppraisalFormData: false,
        dataForAppraisalForm: action.payload
      };
    case ERROR_APPRAISAL_FORM_DATA:
      return {
        ...state,
        isFetchingAppraisalFormData: false,
        dataForAppraisalForm: null
      };
    case REQUEST_SAVE_1004P_FORM_DATA:
      return {
        ...state,
        isSavingAppraisalFormData: true
      };
    case RECEIVE_SAVE_1004P_FORM_DATA:
    case ERROR_SAVE_1004P_FORM_DATA:
      return {
        ...state,
        isSavingAppraisalFormData: false
      };
    case REQUEST_PNX_FORM_EXPORT_DATA:
      return {
        ...state,
        isFetchingPNXFormExportData: true,
        dataForPNXFormExportData: null
      };
    case RECEIVE_PNX_FORM_EXPORT_DATA:
      return {
        ...state,
        isFetchingPNXFormExportData: false,
        dataForPNXFormExportData: action.payload
      };
    case ERROR_PNX_FORM_EXPORT_DATA:
      return {
        ...state,
        isFetchingPNXFormExportData: false,
        dataForPNXFormExportData: null
      };
    case REQUEST_SAVE_PNX_FORM_EXPORT_DATA:
      return {
        ...state,
        isSavingPNXFormExportData: true
      };
    case RECEIVE_SAVE_PNX_FORM_EXPORT_DATA:
      if (!action.payload) {
        return {
          ...state,
          isSavingPNXFormExportData: true
        };
      } else {
        return {
          ...state,
          isSavingPNXFormExportData: false,
          dataForPNXFormExportData: action.payload
        };
      }
    case ERROR_SAVE_PNX_FORM_EXPORT_DATA:
      return {
        ...state,
        isSavingPNXFormExportData: false
      };
    case REQUEST_SUBMIT_TO_QA:
      return {
        ...state,
      };
    case RECEIVE_SUBMIT_TO_QA:
      return {
        ...state,
      };
    case ERROR_SUBMIT_TO_QA:
      return {
        ...state,
      };
    case REQUEST_CASE_HEADER:
      return {
        ...state,
        fetchingCaseHeaderV2: true,
      };
    case RECEIVE_CASE_HEADER:
      return {
        ...state,
        fetchingCaseHeaderV2: false,
        caseHeaderV2: action.payload,
      };
    case ERROR_CASE_HEADER:
      return {
        ...state,
        fetchingCaseHeaderV2: false,
      };
    case REQUEST_ALL_CASE_FORMS:
      return {
        ...state,
        allCaseFormsList: [],
        fetchingAllCaseForms: true,
      };
    case RECEIVE_ALL_CASE_FORMS:
      return {
        ...state,
        allCaseFormsList: action.payload,
        fetchingAllCaseForms: false,
      };
    case ERROR_RETRIEVING_ALL_CASE_FORMS:
      return {
        ...state,
        allCaseFormsList: [],
        fetchingAllCaseForms: false,
      };
    case REQUEST_AVAILABLE_CASE_FORMS:
      return {
        ...state,
        availCaseFormsList: [],
      };
    case RECEIVE_AVAILABLE_CASE_FORMS:
      return {
        ...state,
        availCaseFormsList: action.payload,
      };
    case ERROR_RETRIEVING_AVAILABLE_CASE_FORMS:
      return {
        ...state,
        availCaseFormsList: [],
      };
    case REQUEST_POST_CASE_FORM:
      return {
        ...state,
      };
    case RECEIVE_POST_CASE_FORM:
      return {
        ...state,
        manageForms: false,
        allCaseFormsList: [
          ...state.allCaseFormsList,
        ]
      };
    case ERROR_RETRIEVING_POST_CASE_FORM:
      return {
        ...state,
      };
    case MANAGE_FORMS_DIALOG:
      return {
        ...state,
        manageForms: action.payload,
      };
    case REQUEST_DELETE_CASE_FORM:
      return {
        ...state,
      };
    case RECEIVE_DELETE_CASE_FORM:
      return {
        ...state,
        manageForms: false,
        allCaseFormsList: [
          ...state.allCaseFormsList,
        ]
      };
    case ERROR_RETRIEVING_DELETE_CASE_FORM:
      return {
        ...state,
      };
    case SAVE_COMP_PHOTO_METADATA:
      return {
        ...state,
        compPhotoMetadata: action.payload,
      };
    default:
      return state;
  }
};

export default caseForms;
